  :host {
    position: relative;
    z-index: 3;
  }

  ::slotted(btrix-popover) {
    --show-delay: 300;
  }
